// Curated medical-grade imagery used across the public site.
// Hi-res photographs sourced via Unsplash/Pexels CDN.

export const IMG = {
  // Real surgery / hospital images from Cochlear official site
  ciSurgery:
    "https://assets.cochlear.com/api/public/content/0d1565117064453a8d66508a66b672f3?v=9c451143",
  childPlaying:
    "https://assets.cochlear.com/api/public/content/974ce27f1f7c4cc195d45557b56ddb98?v=bd7ca312",
  childFriends:
    "https://assets.cochlear.com/api/public/content/2d69a451c00340aea040eff963f7dd8e?v=fefd27e3",

  // MED-EL banners
  medelFamily:
    "https://sfc02.cdn.medel.com/images/librariesprovider3/hearing-implants/cochlear-implants/synchrony-2/banner_5.jpg?auto=format&sfvrsn=f5fdfd41_3",
  medelCouple:
    "https://sfc02.cdn.medel.com/images/librariesprovider3/hearing-implants/cochlear-implants/synchrony-2/banner_2.jpg?auto=format&sfvrsn=5ffdfd41_3",
  medelGarden:
    "https://sfc02.cdn.medel.com/images/librariesprovider3/hearing-implants/cochlear-implants/synchrony-2/banner_3.jpg?auto=format&sfvrsn=98fdfd41_3",
  medelOlder:
    "https://sfc02.cdn.medel.com/images/librariesprovider3/hearing-implants/cochlear-implants/synchrony-2/banner_4.jpg?auto=format&sfvrsn=9afdfd41_3",

  // Unsplash / Pexels editorial
  pediatrician:
    "https://images.unsplash.com/photo-1708687045030-26702e62fc65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxwZWRpYXRyaWNpYW4lMjBjaGlsZHxlbnwwfHx8fDE3ODE0ODkxMzh8MA&ixlib=rb-4.1.0&q=85",
  pediatrician2:
    "https://images.unsplash.com/photo-1632053002928-1919605ee6f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxwZWRpYXRyaWNpYW4lMjBjaGlsZHxlbnwwfHx8fDE3ODE0ODkxMzh8MA&ixlib=rb-4.1.0&q=85",
  elderlyCouple:
    "https://images.unsplash.com/photo-1514415008039-efa173293080?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxlbGRlcmx5JTIwY291cGxlJTIwaGFwcHl8ZW58MHx8fHwxNzgxNDg5MTM4fDA&ixlib=rb-4.1.0&q=85",
  elderlyCouple2:
    "https://images.unsplash.com/photo-1625690988276-0a7b0cdf3d5d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxlbGRlcmx5JTIwY291cGxlJTIwaGFwcHl8ZW58MHx8fHwxNzgxNDg5MTM4fDA&ixlib=rb-4.1.0&q=85",
  doctorTeam:
    "https://images.unsplash.com/photo-1638202993928-7267aad84c31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxtZWRpY2FsJTIwdGVhbXxlbnwwfHx8fDE3ODE0ODkxMzh8MA&ixlib=rb-4.1.0&q=85",
  doctorTeam2:
    "https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwdGVhbXxlbnwwfHx8fDE3ODE0ODkxMzh8MA&ixlib=rb-4.1.0&q=85",
  hospital:
    "https://images.unsplash.com/photo-1776659959825-59d28b50dd65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBob3NwaXRhbCUyMGV4dGVyaW9yfGVufDB8fHx8MTc4MTQ4OTEzN3ww&ixlib=rb-4.1.0&q=85",
  hospital2:
    "https://images.unsplash.com/photo-1769147555720-71fc71bfc216?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3NwaXRhbCUyMGV4dGVyaW9yfGVufDB8fHx8MTc4MTQ4OTEzN3ww&ixlib=rb-4.1.0&q=85",
  audiologist:
    "https://images.unsplash.com/photo-1651002520565-b27c9f2b58ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxoZWFyaW5nJTIwZG9jdG9yfGVufDB8fHx8MTc4MTQ4OTEzOHww&ixlib=rb-4.1.0&q=85",
  audiologist2:
    "https://images.unsplash.com/photo-1596088728260-08a654466a00?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxoZWFyaW5nJTIwZG9jdG9yfGVufDB8fHx8MTc4MTQ4OTEzOHww&ixlib=rb-4.1.0&q=85",
  familyChild:
    "https://images.unsplash.com/photo-1603367563698-67012943fd67?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxoYXBweSUyMGZhbWlseSUyMGNoaWxkfGVufDB8fHx8MTc4MTQ4OTE0M3ww&ixlib=rb-4.1.0&q=85",
  familyChild2:
    "https://images.unsplash.com/photo-1624272864537-8ecc72b67958?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxoYXBweSUyMGZhbWlseSUyMGNoaWxkfGVufDB8fHx8MTc4MTQ4OTE0M3ww&ixlib=rb-4.1.0&q=85",
  research:
    "https://images.pexels.com/photos/15831822/pexels-photo-15831822.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  researchLab:
    "https://images.pexels.com/photos/8533136/pexels-photo-8533136.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
